import React from 'react';
import ReactGA from 'react-ga';
import ReactDOM from 'react-dom';
import App from './App';
import Client from 'shopify-buy';
import 'bootstrap/dist/css/bootstrap.css';
  
export const client = Client.buildClient({
  storefrontAccessToken: 'c748f2c011aee04697648bcc049bd0fa',
  domain: 'ann-arbor-tees.myshopify.com',
});
/*
 * Use Javascript to append meta data and title to page
 */
function loadHeadInfo(head_info, body_color) {
  let head = document.getElementsByTagName('head')[0];
  let titleNode = document.createElement('title');
  titleNode.appendChild(document.createTextNode(head_info.title));
  //Append each meta to head
  for (var key in head_info) {
    let metaNode = document.createElement('meta');
    metaNode.setAttribute('name', key);
    metaNode.setAttribute('content', head_info[key]);
    head.appendChild(metaNode);
  }

  head.appendChild(titleNode);

  let body = document.getElementsByTagName('body')[0];
  body.style.backgroundColor = body_color;
}

function setGoogleAnalytics(list) {
  var href = window.location.href;
  var domain = href.slice(href.indexOf(':') + 3);

  for (var idx in list) {
    ReactGA.initialize('UA-8089901-1');
    ReactGA.pageview(domain);
  }
}

//Check if url is in development or production-ish

if (window.location.href.includes('http://localhost:3100/')) {
  //init('http://localhost:3000/api/stores/' + 'starkidreact.annarbortees.com')
  init(
    `https://retail.softwearcrm.com/api/stores/starkidreact.annarbortees.com`,
  );
} else {
  init(
    `https://retail.softwearcrm.com/api/stores/${window.location.hostname}`,
  );
}

function init(url) {
  fetch(url, {
    method: 'GET',
  })
    .then(response => response.json())
    .then(json => {
      if (json['error'] || !json['active']) {
        window.location = 'http://www.annarbortees.com/';
        return;
      }

      //Set Google Analytics tracking in production
      if (!window.location.href.includes('localhost')) {
        setGoogleAnalytics(json.google_tracking_ids);
      }

      //Check if ssl is required
      if (!window.location.href.includes('http://localhost:3100/')) {
        if (json['domains']) {
          let domain = json['domains'][0];
          let require_ssl = domain['require_ssl'];
          if (require_ssl && window.location.protocol !== 'https:') {
            window.location = `https://${domain['value']}${
              window.location.pathname
            }`;
            return;
          }
        }
      }

      //Head information
      let title = json['title'];
      let body_style = json['body_style'];
      let body_html = JSON.stringify(json.body);
      let meta_author = json['meta_author'];
      let meta_description = json['meta_description'];
      let meta_keywords = json['meta_keywords'];
      let header_break_text = json['header_break_text'];
      let header_break_color = '#' + json['header_break_color_one'];
      let rootCollectionID = json['root_collection_id'];
      let headerBackgroundColor = '#' + json['header_background_color'];
      let header_break_background_color =
        '#' + json['header_break_background_color'];
      let buttonColor = header_break_background_color;
      let logo_url = json['header_image_url'];
      let http_colon = logo_url.indexOf(':');
      let logo =
        logo_url.slice(0, http_colon) + 's' + logo_url.slice(http_colon);
      let rootCollection = {
        id: 0,
        display_name: 'Homepage',
        sort_order: '-1',
        slug: '/',
        shopify_collection_id: json['root_collection_id'],
      };
      let collections = [rootCollection];
      let inactiveCollections = [];
      let color = '#' + json['header_color'];
      let navColor_active = '#' + json['sidebar_color_one'];
      let navColor_inactive = '#' + json['sidebar_color_two'];
      let sidebar_background_color = '#' + json['sidebar_background_color'];
      let sidebar_color_one = '#' + json['sidebar_color_one'];
      let sidebar_color_two = '#' + json['sidebar_color_two'];
      let footer_break_background_color =
        '#' + json['footer_break_background_color'];
      let footer_break_color_one = '#' + json['footer_break_color_one'];
      let footer_break_color_two = '#' + json['footer_break_color_two'];
      let footer_background_color = '#' + json['footer_background_color'];
      let footer_color = '#' + json['footer_color'];
      let collection_product_title_color =
        '#' + json['collection_product_title_color'];
      let collection_product_price_color =
        '#' + json['collection_product_price_color'];
      let collection_product_image_background_color =
        '#' + json['collection_product_image_background_color'];
      let collection_display_product_title =
        json['collection_display_product_title'];
      let collection_display_product_price =
        json['collection_display_product_price'];
      let product_title_color = '#' + json['product_title_color'];
      let product_price_color = '#' + json['product_price_color'];
      let product_description_color = '#' + json['product_description_color'];
      let add_to_cart_button_color = '#' + json['add_to_cart_button_color'];
      let add_to_cart_background_color =
        '#' + json['add_to_cart_background_color'];
      let body_background_color = '#' + json['body_background_color'];
      let footer_style = json['footer_style'];
      let footer_html = json['footer_html'];

      json['store_collections'].forEach(collection => {
        collections.push(collection);
      });

      let head_info = {
        title: title,
        meta_author: meta_author,
        meta_description: meta_description,
        meta_keywords: meta_keywords,
        header_break_text: header_break_text,
      };
      let style = {
        header: {backgroundColor: headerBackgroundColor},
        headerColor: color,
        headerBreak: {
          backgroundColor: header_break_background_color,
          color: header_break_color,
        },
        headerBreakColor: header_break_color,
        footerStyle: {
          backgroundColor: footer_break_background_color,
          color: footer_break_color_two,
        },
        footerColor: footer_color,
        footerColorTwo: {color: footer_break_color_two},
        textColor: {color: footer_color},
        button: {backgroundColor: buttonColor},
        buttonColor: buttonColor,
        theme: buttonColor,
        collectionNavColor: {backgroundColor: sidebar_background_color},
        collectionNavTint: {
          color: buttonColor,
          backgroundColor: headerBackgroundColor,
        },
        collectionProductTitleColor: {color: collection_product_title_color},
        collectionProductPriceColor: {color: collection_product_price_color},
        collectionImageBackgroundColor: {
          backgroundColor: collection_product_image_background_color,
        },
        collectionDisplayProductPrice: collection_display_product_price,
        collectionDisplayProductTitle: collection_display_product_title,
        color: buttonColor,
        textColor: color,
        logo: logo,
        sideBar: {backgroundColor: sidebar_background_color},
        navActive: sidebar_color_one,
        navInactive: sidebar_color_two,
        bodyBackgroundColor: {backgroundColor: body_background_color},
        productTitleColor: {color: product_title_color},
        productPriceColor: {color: product_price_color},
        productDescColor: {color: product_description_color},
        addToCartButton: {
          color: add_to_cart_button_color,
          backgroundColor: add_to_cart_background_color,
        },
        footer: {
          footer_style: footer_style,
          footer_html: footer_html,
        },
      };

      loadHeadInfo(head_info, body_background_color);
      ReactDOM.render(
        <App
          client={client}
          debug={false}
          body_style={body_style}
          body_html={body_html}
          customStyle={style}
          header_break_text={head_info['header_break_text']}
          collections={collections}
        />,
        document.getElementById('root'),
      );
    });
}



// WEBPACK FOOTER //
// ./src/index.js